module.exports = __webpack_public_path__ + "static/media/other.3bddd91d.jpg";